<template>
    <PersonalInfoPolicy20260507Content />
</template>

<script>
import PersonalInfoPolicy20260507Content from '@/views/policy/common/PersonalInfoPolicy20260507Content.vue';

export default {
    name: 'PrivacyPolicy20260507',
    components: {
        PersonalInfoPolicy20260507Content,
    },
};
</script>
